import { render, staticRenderFns } from "./Upload-dog-file.vue?vue&type=template&id=343b7f47&scoped=true&"
import script from "./Upload-dog-file.vue?vue&type=script&lang=js&"
export * from "./Upload-dog-file.vue?vue&type=script&lang=js&"
import style0 from "./Upload-dog-file.vue?vue&type=style&index=0&id=343b7f47&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343b7f47",
  null
  
)

export default component.exports